import {
  BOOK_APPOINTMENT,
  BOOK_APPOINTMENT_SUCCESS,
  BOOK_APPOINTMENT_ERROR,
} from '../type';
import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';

const onsiteBookingPatientReducer = handleActions(
  new Map([
    [
      BOOK_APPOINTMENT,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: true },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT_SUCCESS,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: false },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: false },
          },
        });
      },
    ],
  ]),
  initialState,
);
export default onsiteBookingPatientReducer;
